import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { Icon } from '@/ui/common/icon';

export interface KreditBetBannerProps {
  onTry?: () => void;
  loading?: boolean;
  className?: string;
}

/** Figma KreditBetBanner — promo with NEW badge and Try it CTA. */
export function KreditBetBanner({ onTry, loading = false, className }: KreditBetBannerProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex h-[72px] w-full items-center gap-3 rounded-lg border-[1.5px] border-action-primary bg-bg-surface p-3',
        className,
      )}
    >
      <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-action-primary text-text-on-action">
        <Icon name="creditbetin" size={20} className="text-text-on-action" />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-1 overflow-hidden">
        <div className="flex items-center gap-2 overflow-hidden">
          <p className="truncate text-body-m font-bold text-text-primary">
            {t('CreditBet', { defaultValue: 'Kredit Bet' })}
          </p>
          <span className="shrink-0 self-center rounded-sm bg-status-danger px-1.5 py-0.5 text-[9px] leading-none font-bold tracking-normal text-text-primary uppercase">
            {t('New', { defaultValue: 'NEW' })}
          </span>
        </div>
        <p className="truncate text-body-s text-text-secondary">
          {t('CreditBetPromo', {
            defaultValue: 'Bet now, pay later — try our new feature',
          })}
        </p>
      </div>
      <button
        type="button"
        disabled={loading}
        onClick={onTry}
        className="shrink-0 rounded-full bg-action-primary px-3 py-2 text-body-s font-bold text-text-on-action transition-opacity hover:opacity-90 disabled:opacity-60"
      >
        {loading
          ? t('Loading', { defaultValue: '…' })
          : t('TryIt', { defaultValue: 'Try it' })}
      </button>
    </div>
  );
}
